import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '@/component/navbar';
import Dh from '@/components/Dh';

type Choice = 'expedited' | 'no-thanks';

const RadioCircle = ({ selected }: { selected: boolean }) => (
  <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center shrink-0 ${selected ? 'border-amber-500' : 'border-gray-400'}`}>
    {selected && <div className="w-2.5 h-2.5 rounded-full bg-amber-500" />}
  </div>
);

export default function SetupExpedited() {
  const [selected, setSelected] = useState<Choice>('expedited');
  const navigate = useNavigate();

  const handleNext = () => {
    localStorage.setItem('setupExpedited', selected);
    if (selected === 'expedited') {
      navigate('/setup-upgrade');
    } else {
      navigate('/setup-invoice');
    }
  };

  const cards: { id: Choice; title: string; description: string; price?: string; billing?: string }[] = [
    {
      id: 'expedited',
      title: 'Expedited Formation',
      description: 'Skip the line with the Emirate and get your business formed as quick as possible',
      price: '300',
      billing: 'One-time',
    },
    {
      id: 'no-thanks',
      title: 'No Thanks',
      description: 'I can wait a week or more for my company to be formed.',
    },
  ];

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col">
      <Navbar hideSignBtn={false} />
      <div className="flex-1 px-8 py-16 max-w-5xl mx-auto w-full">
        <h1 className="text-2xl font-bold text-gray-900 mb-10">
          Choose a plan to power up your business
        </h1>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-10">
          {cards.map((card) => {
            const isSelected = selected === card.id;
            return (
              <div
                key={card.id}
                onClick={() => setSelected(card.id)}
                className="rounded-xl p-6 cursor-pointer flex flex-col transition-all duration-200"
                style={{
                  backgroundColor: isSelected ? '#FFFBEB' : '#F9FAFB',
                  border: isSelected ? '2px solid #F59E0B' : '2px solid #E5E7EB',
                }}
              >
                <h3 className="text-lg font-bold text-gray-900 mb-2">{card.title}</h3>
                <p className="text-sm text-gray-600 mb-8 leading-relaxed">{card.description}</p>
                <div className="flex items-end justify-between mt-auto">
                  <div>
                    {card.price && (
                      <div className="flex items-baseline gap-2">
                        <span className="text-2xl font-bold text-gray-900 inline-flex items-baseline"><Dh em="0.8" />{card.price}</span>
                        <span className="text-sm text-gray-500">{card.billing}</span>
                      </div>
                    )}
                  </div>
                  <RadioCircle selected={isSelected} />
                </div>
              </div>
            );
          })}
        </div>

        <div className="flex items-center gap-4">
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="px-8 py-3 border-2 border-gray-300 rounded-lg font-medium text-gray-700 bg-white hover:bg-gray-50 transition-colors"
          >
            ← Back
          </button>
          <button
            type="button"
            onClick={handleNext}
            className="px-8 py-3 bg-amber-400 text-gray-900 font-semibold rounded-lg hover:bg-amber-500 transition-colors"
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
}
